(function () {
    "use strict";

    const FIP_MENU_BUTTON = ".fip-detail-header__fip-menu";
    const FIP_MENU = ".fip-detail-menu";
    const FIP_MENU_CLOSE = ".fip-detail-menu__close"

    const FIP_MENU__ACTIVE = "fip-detail-menu--active";

    $(FIP_MENU_BUTTON).each((index, fipMenu) => {
        const menu = $(fipMenu);
        menu.on("click", (event) => {
            const button = $(event.target).closest('button');
            const menu = button.parent().find(FIP_MENU);

            menu.toggleClass(FIP_MENU__ACTIVE);
        });
    });

    $(FIP_MENU_CLOSE).each((index, fipclose) => {
        const close = $(fipclose);
        close.on("click", (event) => {
            const button = $(event.target).closest('button');
            const menu = button.closest(FIP_MENU);

            menu.removeClass(FIP_MENU__ACTIVE);
        });
    });
})();
